// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__-r1UU","question":"Question_question__36GDs","description":"Question_description__2gzzq"};